import React from "react"
import { useParams } from "react-router-dom"

export const KeyDatesPage: React.FC = () => {
    const { id } = useParams<{ id: string }>()

    return (
        <div>
            <h1>Key Dates</h1>
            <p>Campaign ID: {id}</p>
        </div>
    )
}
